module.exports = __webpack_public_path__ + "static/img/analysis-template.1cbf6702.svg";